import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { InputPropertiesType } from "@website/ui/datepicker/components/input/input.types";
import { MONTH_NAMES } from "@website/ui/datepicker/constanst";
import { numberConvert } from "@website/utils/number-convert";
export const useInput = properties => {
  const $ = _c(40);
  const {
    id,
    fromTitle,
    toTitle,
    value,
    setMode,
    calendarLocale,
    onOpenPopover,
    disabled,
    size: t0,
    noBorder,
    hasDropdownIcon,
    isCalendarHeader
  } = properties;
  const size = t0 === undefined ? "default" : t0;
  let t1;
  bb0: {
    if (value?.[0]) {
      const month = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[value[0].month - 1];
      let t2;
      if ($[0] !== value[0].day) {
        t2 = numberConvert(value[0].day, {
          numberOnly: true,
          locale: "fa"
        });
        $[0] = value[0].day;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      const day = t2;
      t1 = `${day} ${month}`;
      break bb0;
    }
    t1 = "";
  }
  const startTextFieldValue = t1;
  let t2;
  bb1: {
    if (value?.[1]) {
      const month_0 = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[value?.[1].month - 1];
      const t3 = value?.[1].day;
      let t4;
      if ($[2] !== t3) {
        t4 = numberConvert(t3, {
          numberOnly: true,
          locale: "fa"
        });
        $[2] = t3;
        $[3] = t4;
      } else {
        t4 = $[3];
      }
      const day_0 = t4;
      t2 = `${day_0} ${month_0}`;
      break bb1;
    }
    t2 = "";
  }
  const endTextFieldValue = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      tabIndex: 0
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = value?.[0] ? fromTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u0634\u0631\u0648\u0639" : "";
  const t5 = value?.[0] ? "" : fromTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u0634\u0631\u0648\u0639";
  let t6;
  if ($[5] !== isCalendarHeader) {
    t6 = isCalendarHeader ? <MaterialIcon name="date_range" variant="outlined" /> : undefined;
    $[5] = isCalendarHeader;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== hasDropdownIcon) {
    t7 = hasDropdownIcon && <MaterialIcon name="arrow_drop_down" variant="fill" />;
    $[7] = hasDropdownIcon;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== disabled || $[10] !== noBorder || $[11] !== onOpenPopover || $[12] !== size || $[13] !== startTextFieldValue || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = {
      "data-testid": "date_picker_start_input",
      label: t4,
      placeholder: t5,
      StartIcon: t6,
      EndIcon: t7,
      readOnly: true,
      value: startTextFieldValue,
      onClick: onOpenPopover,
      fullWidth: true,
      disabled,
      size,
      noBorder
    };
    $[9] = disabled;
    $[10] = noBorder;
    $[11] = onOpenPopover;
    $[12] = size;
    $[13] = startTextFieldValue;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = value?.[1] ? toTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u067E\u0627\u06CC\u0627\u0646" : "";
  const t10 = value?.[1] ? "" : toTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u067E\u0627\u06CC\u0627\u0646";
  let t11;
  if ($[19] !== hasDropdownIcon) {
    t11 = hasDropdownIcon && <MaterialIcon name="arrow_drop_down" variant="fill" />;
    $[19] = hasDropdownIcon;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== disabled || $[22] !== endTextFieldValue || $[23] !== id || $[24] !== noBorder || $[25] !== onOpenPopover || $[26] !== size || $[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = {
      id,
      "data-testid": "date_picker_end_input",
      label: t9,
      placeholder: t10,
      readOnly: true,
      value: endTextFieldValue,
      onClick: onOpenPopover,
      fullWidth: true,
      EndIcon: t11,
      disabled,
      size,
      noBorder
    };
    $[21] = disabled;
    $[22] = endTextFieldValue;
    $[23] = id;
    $[24] = noBorder;
    $[25] = onOpenPopover;
    $[26] = size;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== setMode) {
    t13 = setMode?.bind(null, "start-end");
    $[31] = setMode;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13) {
    t14 = {
      role: "button",
      onClick: t13
    };
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = toTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u067E\u0627\u06CC\u0627\u0646";
  let t16;
  if ($[35] !== t12 || $[36] !== t14 || $[37] !== t15 || $[38] !== t8) {
    t16 = {
      rootProps: t3,
      startTextFieldProperties: t8,
      endTextFieldProperties: t12,
      endEnableButtonProperties: t14,
      endEnableButtonText: t15
    };
    $[35] = t12;
    $[36] = t14;
    $[37] = t15;
    $[38] = t8;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};